import { ApiService, toModels } from '~/shared/api'
import { BreadcrumbItem } from '~/models/breadcrumbs'
import { API_PREFIX } from '~/shared/const/request-services'

export class BreadcrumbsService extends ApiService {
  getList(url: string, rubricId?: number | string): Promise<BreadcrumbItem[]> {
    const params: Record<string, string | number> = { url }
    if (rubricId) {
      params.rubric_id = rubricId
    }

    return this.http
      .request({ url: `${API_PREFIX}/breadcrumbs`, params })
      .then(toModels(BreadcrumbItem))
  }
}
